import React, { useState, useCallback, useRef, useEffect } from "react";
import { getCompanyName, ScreenNameList } from "@lib/utilities/Constants";
import { useAppDispatch, useAppSelector } from "@lib";

import { useFocusEffect } from "@react-navigation/native";
import Crashlytics from "@lib/utilities/crashlyticsUtils/CrashlyticsUtils";
import { BILLING_PAYMENTS_ROUTE } from "../../../src/navigation/NavigationConstants";
import { messages } from "../../../src/resources/strings";
import { setError, setLoading } from "@lib";
import { billingHandler } from "@lib";
import { getPaymentInfo } from "@lib/utilities/HelperFunctions";
import { policyApiHandler } from "@lib";
import { introspectionAPI } from "@lib";

export const useBillingPayments = () => {
  const [expandedIndex, setExpandedIndex] = useState<number>(-1);
  const [isPayNowVisible, setIsPayNowVisible] = useState(false);
  // redux
  const { fetchPayments } = billingHandler();
  const [isPaymentVisible, setIsPaymentVisible] = useState<boolean>(false);
  const policyData = useAppSelector((state) => state.policyReducer);
  const dispatch = useAppDispatch();
  const hasFetchedPaymentsRef = useRef(false);
  const { refetchPolicyDetailData } = policyApiHandler((message: string) => {
    dispatch(setError(message));
  });
  const {
    billingDetails,
    payments,
    loading,
    error,
    policyNumber,
    enabledPayment,
  } = useAppSelector((state) => state.policyDetailReducer);

  const togglefetchedPaymentsRef = (flag: boolean) => {
    hasFetchedPaymentsRef.current = flag;
  };
  const refetchData = () => {
    fetchPayments();
    refetchPolicyDetailData();
  };

  useEffect(() => {
    const checkPayNowVisible = async () => {
      if (billingDetails) {
        const amount = getPaymentInfo(
          billingDetails.information.nextPayment?.value,
          billingDetails.premium.balanceDue?.value,
        );
        const companyName = await getCompanyName();

        setIsPayNowVisible(
          enabledPayment && Number(amount) > 0 && companyName != "HCPCI",
        );
      }
      const isIntrospectionValid = await introspectionAPI();
      if (!isIntrospectionValid?.response) {
        dispatch(setError(messages.error.sessionExpired));
      }
    };

    checkPayNowVisible();
  }, [billingDetails]);
  useFocusEffect(
    React.useCallback(() => {
      Crashlytics.logScreen(BILLING_PAYMENTS_ROUTE);
      try {
        setIsPaymentVisible(false);
        if (!hasFetchedPaymentsRef.current && policyData?.policies?.length) {
          togglefetchedPaymentsRef(true);
          fetchPayments()
            .then(() => {
              togglefetchedPaymentsRef(false);
            })
            .catch(() => {
              togglefetchedPaymentsRef(false);
            });
        }
      } catch (e) {
        fetchPayments();
      }
    }, [policyData?.policies?.length, policyData.policyNumber]),
  );

  const onReloadPress = useCallback(() => {
    fetchPayments();
    setExpandedIndex(-1);
    if (policyNumber) {
      dispatch(setError(messages.error.noError));
    }
  }, [policyNumber]);

  const toggleExpandedView = useCallback((index: number) => {
    setExpandedIndex((prev) => (prev === index ? -1 : index));
  }, []);

  // Calculations
  const getTotalPaymentAmount = () => {
    if (billingDetails?.information?.cashReceived?.value) {
      return billingDetails?.information?.cashReceived?.value;
    } else {
      return payments.reduce(
        (prev: number, current: any) => prev + Number(current.amount),
        0,
      );
    }
  };

  const errorData = {
    message: error,
    screenName: ScreenNameList.billingPayments,
  };

  const onPaymentButtonPress = async () => {
    const companyName = await getCompanyName();
    if (companyName == "HCPCI") {
      dispatch(setError(messages.error.featureNotAvailable));
      return;
    }

    setIsPaymentVisible(true);
    // TODO : Open payment modal in browser
  };

  const onPaymentModalClose = async () => {
    setIsPaymentVisible(false);
  };

  return {
    // States
    loading: loading,
    error,
    errorData,
    policyNumber,
    expandedIndex,
    payments,
    billings: billingDetails,
    policyData,
    isPaymentVisible,
    isPayNowVisible,

    // Methods
    toggleExpandedView,
    onPaymentButtonPress,
    onPaymentModalClose,
    onReloadPress,
    getTotalPaymentAmount,
    setErrorHandle: (message: string) => dispatch(setError(message)),
    refetchData,
  };
};
